<app-auth-layout>
    @if (!_verifyTokenReturnStruct) {
    <!-- Verificando o link -->
    <div class="auth-carregando">
        <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    }
    @else if (_verifyTokenReturnStruct.isError) {
    <!-- Link inválido ou expirado -->
    <div class="auth-stack auth-center">
        <span class="auth-icon-badge auth-icon-badge--error" aria-hidden="true">
            <mat-icon class="material-symbols-outlined">link_off</mat-icon>
        </span>
        <div class="auth-heading">
            <h1>Link inválido ou expirado</h1>
            <p>Solicite um novo link para criar a sua senha</p>
        </div>
        <div class="auth-acoes-coluna">
            <button type="button" mat-flat-button class="btn-primary auth-btn" (click)="redirectRecuperarSenha()">
                Solicitar novo link
                <mat-icon iconPositionEnd class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
            </button>
        </div>
        <button type="button" class="auth-link" (click)="redirectLogin()">Voltar para o login</button>
    </div>
    }
    @else if (senhaAlterada) {
    <!-- Senha alterada com sucesso -->
    <div class="auth-stack auth-center">
        <span class="auth-icon-badge auth-icon-badge--success" aria-hidden="true">
            <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
        </span>
        <div class="auth-heading">
            <h1>Senha alterada com sucesso</h1>
            <p>Pronto! Agora é só entrar com a sua nova senha</p>
        </div>
        <div class="auth-acoes-coluna">
            <button type="button" mat-flat-button class="btn-primary auth-btn" (click)="redirectLogin()">
                Ir para o login
                <mat-icon iconPositionEnd class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
            </button>
        </div>
    </div>
    }
    @else {
    <!-- Criar nova senha -->
    <div class="auth-stack">
        <div class="auth-intro">
            <span class="auth-icon-badge" aria-hidden="true">
                <mat-icon class="material-symbols-outlined">password</mat-icon>
            </span>
            <div class="auth-heading">
                <h1>Crie uma nova senha</h1>
                <p>Informe e confirme a sua nova senha para continuar</p>
            </div>
        </div>

        <form class="auth-form" [formGroup]="model" (ngSubmit)="post()">
            <mat-form-field appearance="outline">
                <mat-label>Nova senha</mat-label>
                <mat-icon matPrefix class="material-symbols-outlined auth-prefix-icon">lock</mat-icon>
                <input matInput [type]="hideSenha1() ? 'password' : 'text'" formControlName="senha1"
                    autocomplete="new-password" placeholder="Digite a nova senha">
                <button type="button" mat-icon-button matSuffix (click)="clickEventSenha1($event)"
                    [attr.aria-label]="hideSenha1() ? 'Mostrar senha' : 'Ocultar senha'"
                    [attr.aria-pressed]="!hideSenha1()">
                    <mat-icon>{{hideSenha1() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                @if (model.get('senha1')?.invalid) {
                <mat-error>Informe a nova senha</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Repetir nova senha</mat-label>
                <mat-icon matPrefix class="material-symbols-outlined auth-prefix-icon">lock</mat-icon>
                <input matInput [type]="hideSenha2() ? 'password' : 'text'" formControlName="senha2"
                    autocomplete="new-password" placeholder="Digite novamente">
                <button type="button" mat-icon-button matSuffix (click)="clickEventSenha2($event)"
                    [attr.aria-label]="hideSenha2() ? 'Mostrar senha' : 'Ocultar senha'"
                    [attr.aria-pressed]="!hideSenha2()">
                    <mat-icon>{{hideSenha2() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                @if (model.get('senha2')?.invalid) {
                <mat-error>Informe a nova senha novamente</mat-error>
                }
            </mat-form-field>

            <button type="submit" mat-flat-button class="btn-primary auth-btn">
                @if (isLoading) {
                <mat-spinner [diameter]="24"></mat-spinner>
                }
                @else {
                Salvar nova senha
                }
            </button>
        </form>

        <button type="button" class="auth-link auth-link--centro" (click)="redirectLogin()">Voltar para o login</button>
    </div>
    }
</app-auth-layout>
